import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { LicenseInfo } from '@mui/x-license';

import Loader from '../../components/Loader/Loader';
import { AuthState } from '@clatter/platform';

LicenseInfo.setLicenseKey(process.env.NX_PUBLIC_MUI_LICENSE_KEY);

const RootProvider = ({ store, App, usePersistence = true }) => {
  const persistor = usePersistence ? persistStore(store) : null;

  const content = (
    <StrictMode>
      <BrowserRouter>
        <AuthState>
          <App />
        </AuthState>
      </BrowserRouter>
    </StrictMode>
  );

  // 'home' app is not using persist gate...
  return (
    <Provider store={store}>
      {usePersistence ? (
        <PersistGate loading={<Loader />} persistor={persistor}>
          {content}
        </PersistGate>
      ) : (
        content
      )}
    </Provider>
  );
};

export const renderApp = (store, App, rootElementId = 'root', usePersistence = true) => {
  const root = createRoot(document.getElementById(rootElementId));
  root.render(<RootProvider store={store} App={App} usePersistence={usePersistence} />);
};
